/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GeneralActionOnEmailDataDto } from '../models';
// @ts-ignore
import type { NewEmailDataDto } from '../models';
/**
 * RestEmailSenderApi - axios parameter creator
 */
export const RestEmailSenderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailFromDraft: async (userId: string, emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendEmailFromDraft', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('sendEmailFromDraft', 'emailId', emailId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForwardEmail: async (userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendForwardEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('sendForwardEmail', 'emailId', emailId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('sendForwardEmail', 'data', data)
            // verify required parameter 'attachments' is not null or undefined
            assertParamExists('sendForwardEmail', 'attachments', attachments)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/forward`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (data !== undefined) { 
                localVarFormParams.append('data', new Blob([JSON.stringify(data, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {NewEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewEmail: async (userId: string, data: NewEmailDataDto, attachments: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendNewEmail', 'userId', userId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('sendNewEmail', 'data', data)
            // verify required parameter 'attachments' is not null or undefined
            assertParamExists('sendNewEmail', 'attachments', attachments)
            const localVarPath = `/api/users/{userId}/emails/force/send-new`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (data !== undefined) { 
                localVarFormParams.append('data', new Blob([JSON.stringify(data, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReplyAllEmail: async (userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendReplyAllEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('sendReplyAllEmail', 'emailId', emailId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('sendReplyAllEmail', 'data', data)
            // verify required parameter 'attachments' is not null or undefined
            assertParamExists('sendReplyAllEmail', 'attachments', attachments)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/reply-all`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (data !== undefined) { 
                localVarFormParams.append('data', new Blob([JSON.stringify(data, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReplyToEmail: async (userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendReplyToEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('sendReplyToEmail', 'emailId', emailId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('sendReplyToEmail', 'data', data)
            // verify required parameter 'attachments' is not null or undefined
            assertParamExists('sendReplyToEmail', 'attachments', attachments)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/reply`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (data !== undefined) { 
                localVarFormParams.append('data', new Blob([JSON.stringify(data, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmailSenderApi - functional programming interface
 */
export const RestEmailSenderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmailSenderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailFromDraft(userId: string, emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailFromDraft(userId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailSenderApi.sendEmailFromDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendForwardEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendForwardEmail(userId, emailId, data, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailSenderApi.sendForwardEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {NewEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNewEmail(userId: string, data: NewEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNewEmail(userId, data, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailSenderApi.sendNewEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReplyAllEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReplyAllEmail(userId, emailId, data, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailSenderApi.sendReplyAllEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReplyToEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReplyToEmail(userId, emailId, data, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailSenderApi.sendReplyToEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmailSenderApi - factory interface
 */
export const RestEmailSenderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmailSenderApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailFromDraft(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendEmailFromDraft(userId, emailId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForwardEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendForwardEmail(userId, emailId, data, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {NewEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewEmail(userId: string, data: NewEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendNewEmail(userId, data, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReplyAllEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendReplyAllEmail(userId, emailId, data, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {GeneralActionOnEmailDataDto} data 
         * @param {Array<File>} attachments 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReplyToEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendReplyToEmail(userId, emailId, data, attachments, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmailSenderApi - interface
 */
export interface RestEmailSenderApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendEmailFromDraft(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendForwardEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {NewEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendNewEmail(userId: string, data: NewEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendReplyAllEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendReplyToEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEmailSenderApi - object-oriented interface
 */
export class RestEmailSenderApi extends BaseAPI implements RestEmailSenderApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendEmailFromDraft(userId: string, emailId: string, options?: RawAxiosRequestConfig) {
        return RestEmailSenderApiFp(this.configuration).sendEmailFromDraft(userId, emailId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendForwardEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig) {
        return RestEmailSenderApiFp(this.configuration).sendForwardEmail(userId, emailId, data, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {NewEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendNewEmail(userId: string, data: NewEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig) {
        return RestEmailSenderApiFp(this.configuration).sendNewEmail(userId, data, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendReplyAllEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig) {
        return RestEmailSenderApiFp(this.configuration).sendReplyAllEmail(userId, emailId, data, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {GeneralActionOnEmailDataDto} data 
     * @param {Array<File>} attachments 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendReplyToEmail(userId: string, emailId: string, data: GeneralActionOnEmailDataDto, attachments: Array<File>, options?: RawAxiosRequestConfig) {
        return RestEmailSenderApiFp(this.configuration).sendReplyToEmail(userId, emailId, data, attachments, options).then((request) => request(this.axios, this.basePath));
    }
}

